import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import withPermissionsAccessControl from 'src/hooks/useFeatureFlags/withPermissionsAccessControl';

const styles = StyleSheet.create({
  container: {
    minWidth: '8dvw',
    width: '15dvw',
    maxWidth: '15dvw',
    borderLeftWidth: 1,
    borderLeftColor: colors['color-gray-80'],
  },
  badge: {
    backgroundColor: colors['color-danger-500'],
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
  },
  badgeText: {
    color: colors['color-text-white'],
  },
});

interface ComplianceHeaderControlProps {
  compliancePanelVisible: boolean;
  setCompliancePanelVisible: (visible: boolean) => void;
  failedCount: number;
}

const ComplianceHeaderControlBase: React.FC<ComplianceHeaderControlProps> = ({
  compliancePanelVisible,
  setCompliancePanelVisible,
  failedCount,
}) => {
  if (!compliancePanelVisible) {
    return (
      <DNAButton
        appearance="outline"
        status="tertiary"
        iconLeft="shield-check"
        children="Check compliance"
        onPress={() => setCompliancePanelVisible(true)}
        testID="check-compliance-button"
      />
    );
  }

  return (
    <DNABox
      appearance="row"
      spacing="between"
      alignY="center"
      style={styles.container}
    >
      <DNABox spacing="sm" alignY="center">
        <DNAText h5 bold>
          Rules
        </DNAText>
        {failedCount > 0 && (
          <DNABox style={styles.badge}>
            <DNAText c2 bold style={styles.badgeText}>
              {failedCount} FAILED
            </DNAText>
          </DNABox>
        )}
      </DNABox>
      <DNAButton
        appearance="ghost"
        status="tertiary"
        iconLeft="x"
        onPress={() => setCompliancePanelVisible(false)}
        testID="compliance-panel-close-button"
      />
    </DNABox>
  );
};

const ComplianceHeaderControl = withPermissionsAccessControl(ComplianceHeaderControlBase, {
  flags: ['BEAC_7570_compliance_checker'],
});

export default ComplianceHeaderControl;
